import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, money } from "@/lib/api";

export default function Orders() {
  const [orders, setOrders] = useState([]);
  useEffect(() => { api.get("/me/orders").then((r) => setOrders(r.data)); }, []);
  return (
    <div>
      <div className="overline mb-4">Your orders</div>
      {orders.length === 0 ? (
        <div className="border border-dashed border-black/20 p-10 text-center text-zinc-600">No orders yet.</div>
      ) : (
        <div className="border border-black/10 divide-y divide-black/10">
          {orders.map((o) => (
            <Link key={o.id} to={`/account/orders/${o.id}`} className="p-4 flex items-center justify-between hover:bg-zinc-50" data-testid={`order-row-${o.order_number}`}>
              <div>
                <div className="font-mono text-sm">{o.order_number}</div>
                <div className="text-xs text-zinc-500 mt-1">{new Date(o.created_at).toLocaleString()} · {o.items.length} item(s)</div>
              </div>
              <div className="text-right">
                <div className="font-mono">{money(o.total_cents)}</div>
                <div className="overline mt-1">{o.status}</div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
